export interface GpuTexture {
  texture: WebGLTexture;
  size: number;
}

export const uploadAtlasTexture = (
  gl: WebGL2RenderingContext,
  buffer: ArrayBuffer,
  size: number,
): GpuTexture => {
  const tex = gl.createTexture();
  if (tex === null) throw new Error('gl.createTexture returned null');
  gl.bindTexture(gl.TEXTURE_2D, tex);
  const view = new Uint8Array(buffer);
  gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA8, size, size, 0, gl.RGBA, gl.UNSIGNED_BYTE, view);
  gl.generateMipmap(gl.TEXTURE_2D);
  // Crisp low-poly: nearest at min (with mip nearest), linear at mag.
  gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.NEAREST_MIPMAP_NEAREST);
  gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.LINEAR);
  gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE);
  gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);
  gl.bindTexture(gl.TEXTURE_2D, null);
  return { texture: tex, size };
};

export const disposeGpuTexture = (gl: WebGL2RenderingContext, t: GpuTexture): void => {
  gl.deleteTexture(t.texture);
};
